import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, type OnDestroy, type OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { PagePath } from '../../enums/page-path.enum';
import { SelectedDrug } from '../../models/drug.model';
import { DrugService } from '../../services/drug.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-prescription-container',
  templateUrl: './prescription-container.component.html',
  styleUrls: ['./prescription-container.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class PrescriptionContainerComponent implements OnInit, OnDestroy {
  private readonly drugService = inject(DrugService);
  private readonly router = inject(Router);
  private readonly navigationService = inject(NavigationService);
  private readonly cdr = inject(ChangeDetectorRef);

  selectedDrugs$: Observable<SelectedDrug[]> = this.drugService.getSelectedDrugs$();
  selectedDrugs: SelectedDrug[] = [];
  isHomePage = false;
  private readonly subscriptions = new Subscription();

  ngOnInit(): void {
    this.subscriptions.add(
      this.selectedDrugs$.subscribe({
        next: selectedDrugs => {
          this.selectedDrugs = selectedDrugs;
          this.cdr.markForCheck();
        }
      })
    );
    // Check if current route is home page
    const currentUrl = this.router.url;
    this.isHomePage = currentUrl === PagePath.HOME || currentUrl === '/' || currentUrl === '';
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  goToPrescriptions(): void {
    this.navigationService.navigateToPagePath([PagePath.ACCOUNT_PRESCRIPTIONS]);
  }
}
